import { Resource } from 'ia-react-core';
import React, { FC } from 'react';
import { getHostName } from 'omni-package-react-cms';
import { DictionaryGlobalClass } from '../../interfaces/SiteCoreDictionaryInterface';

export interface DictionaryLoaderProps {
}

const DictionaryLoader: FC<DictionaryLoaderProps> = () => {
  const sitecorePath = getHostName();
  return (
    <Resource
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      transformResponse={(data: any) => new DictionaryGlobalClass(data)}
      name="SiteCoreDictionaryResource"
      url={`${sitecorePath}/cw/api/dictionary`}
      dataDst="SiteCoreDictionary"
      requestOnLanguageChange
      autoRequest
    />
  );
};

export default DictionaryLoader;
